import React, { useRef } from 'react'
import { Box, Typography, Container, Grid, Rating, Card, CardMedia, Link, CardContent,  Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button, Breadcrumbs, CardActionArea, Dialog, DialogContent,DialogActions, DialogTitle, DialogContentText, Stack, TextField, List, Collapse, ListItemButton, ListItemIcon, ListItemText, IconButton, InputAdornment, Input, Divider } from '@mui/material'
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AddBox, EmailOutlined } from '@mui/icons-material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { add_Income_sheet, add_income_statement, get_Income_sheet, get_sales_expenses_for_income_statement } from '../../../Services/APIService';
import CustomTextField from '../../../Components/CustomTextField';
import SnackBar from '../../../Components/AdminDashBoardComps/Snackbar';


export default function IncomeSheet({setValue}) {

  const [IncomeSheetPeriod, setIncomeSheetPeriod] = useState(null);
  const [sales, setSales] = useState(0);
  const [otherProductionExpenses, setOtherProductionExpenses] = useState(0);
  const [totalCostOfSales, setTotalCostOfSales] = useState(0);
  const [grossMargin, setGrossMargin] = useState(0);
  const [grossMarginPercentage, setGrossMarginPercentage] = useState(0);
  const datePickerRef = useRef(null);
  const [inventory, setInventory] = useState(0);
  const [utilities, setUtilities] = useState(null);
  const [marketing, setMarketing] = useState(null);
  const [humanResource, setHumanResource] = useState(null);
  const [insurance, setInsurance] = useState(null);
  const [licenses, setLicenses] = useState(null);
  const [systemDevelopment, setSystemDevelopment] = useState(null);
  const [officeEquipments, setOfficeEquipments] = useState(null);
  const [customTaxes, setCustomTaxes] = useState(null);
  const [shipping, setShipping] = useState(null);
  const [totalExpense, setTotalExpense] = useState(0);
  const [ebitda, setEbitda] = useState(0);
  const [interestExpense, setInterestExpense] = useState(0);
  const [taxes, setTaxes] = useState(0);
  const [netProfit, setNetProfit] = useState(0);

  
  const [fuelAndGas, setFuelAndGas] = useState(0);
  const [travelsMealsAndEntertainments, setTravelsMealsAndEntertainments] = useState(0);
  const [equipmentRental, setEquipmentRental] = useState(0);
  const [advertisingAndPromotions, setAdvertisingAndPromotions] = useState(0);
  const [websiteDevelopment, setWebsiteDevelopment] = useState(0);
  const [toolsAndEquipment, setToolsAndEquipment] = useState(0);
  const [salaryAndWages, setSalaryAndWages] = useState(0);
  const [bankCharges, setBankCharges] = useState(0);
  const [shippingAndLogisticsCost, setShippingAndLogisticsCost] = useState(0);
  const [otherExpenses, setOtherExpenses] = useState(0);
  const [governmentFees, setGovernmentFees] = useState(0);
  const [communicationAndTelecom, setCommunicationAndTelecom] = useState(0);
  const [carInsurance, setCarInsurance] = useState(0);
  const [membershipAndSubscriptions, setMembershipAndSubscriptions] = useState(0);
  const [carMaintenanceAndRepairs, setCarMaintenanceAndRepairs] = useState(0);
  const [maintenanceAndRepairs, setMaintenanceAndRepairs] = useState(0);
  const [rent, setRent] = useState(0);

  const [stationeriesAndSupplies, setStationeriesAndSupplies] = useState(0);
 
  const [stationeries_and_Supplies, setStationeriesSupplies] = useState(0);

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState();
  const [color, setColor] = useState();
  const [data , setData] = useState([]);

  const [financialYear, setFinancialYear] = useState(null);

  const handleDateChange = (date) => {
    setFinancialYear(date);
    const year = date.year(); 
 
    setIncomeSheetPeriod(year);
  };
  


  const getallData = () =>{
    if(IncomeSheetPeriod !== null && IncomeSheetPeriod !== '' && IncomeSheetPeriod !== undefined){
    const sendData = new FormData()
    sendData.append('incomePeriod' , IncomeSheetPeriod)
    axios({
        method: "POST",
        url: get_sales_expenses_for_income_statement,
        data:sendData
    }).then(response => {
        if (!response.data.error) {
            setOpen(true)
            setMessage(response.data.message)
            setStatus(true)
            setColor(true)
            setSales(response.data.data.sales);
            // setTaxes(res.data.data.tax);

          
        setInventory(response.data.data.inventory);
        setFuelAndGas(response.data.data.fuel_and_gas);
        setTravelsMealsAndEntertainments(response.data.data.travels_meals_and_entertainments);
        setEquipmentRental(response.data.data.equipment_rental);
        setAdvertisingAndPromotions(response.data.data.advertising_and_promotions);
        setWebsiteDevelopment(response.data.data.website_development);
        setToolsAndEquipment(response.data.data.tools_and_equipment);
        setSalaryAndWages(response.data.data.salary_and_wages);
        setBankCharges(response.data.data.bank_charges);
        setShippingAndLogisticsCost(response.data.data.shipping_and_logistics_cost);
        setOtherExpenses(response.data.data.other_expenses);
        setGovernmentFees(response.data.data.government_fees);
        setCommunicationAndTelecom(response.data.data.communication_and_telecom);
        setCarInsurance(response.data.data.car_insurance);
        setMembershipAndSubscriptions(response.data.data.membership_and_subscriptions);
        setCarMaintenanceAndRepairs(response.data.data.car_maintenance_and_repairs);
        setMaintenanceAndRepairs(response.data.data.maintenance_and_repairs);
        setRent(response.data.data.rent);
        setInventory(response.data.data.inventory);
        setStationeriesAndSupplies(response.data.data.stationeries_and_supplies);
        // setUtilities(res.data.data.utilities);
        // setMarketing(res.data.data.marketing);
        // setHumanResource(res.data.data.humanResource);
        // setInsurance(res.data.data.insurance);
        // setLicenses(res.data.data.licenses);
        // setSystemDevelopment(res.data.data.systemDevelopment);
        // setOfficeEquipments(res.data.data.officeEquipments);
        // setCustomTaxes(res.data.data.customTaxes);
        // setShipping(res.data.data.shipping);

        } else {
          setMessage(response.data.message)
          setOpen(true)
          setStatus(false)
          setColor(false)     
        }
    }).catch(err => {
        console.log(err)
    });
  }
    }

    useEffect(()=>{
      getallData();
    },[IncomeSheetPeriod])


    useEffect(()=>{
      if(sales !== 0 && sales !== null && sales !== undefined){
      const parsedSales = parseFloat(sales) || 0;
      const parsedotherProductionExpenses = parseFloat(otherProductionExpenses) || 0;
      setGrossMargin((parsedSales - parsedotherProductionExpenses).toFixed(2));
      }
      else{
        setGrossMargin(0);
      }
    },[sales, otherProductionExpenses])


    useEffect(() => {
      if(sales !== 0 && sales !== null && sales !== undefined && grossMargin !== 0 && grossMargin !== null && grossMargin !== undefined){
      const parsedSales = parseFloat(sales) || 0;
      const parsedGrossMargin = parseFloat(grossMargin) || 0;
      // let calculatedGrossMarginPercentage = ((parsedGrossMargin / parsedSales) * 100).toFixed(2);
     

      let calculatedGrossMarginPercentage = (parsedSales !== 0)
  ? ((parsedGrossMargin / parsedSales) * 100).toFixed(2)
  : 0; // Prevent division by zero


      if (isNaN(calculatedGrossMarginPercentage)) {
        calculatedGrossMarginPercentage = "0.00";
      }
     
      const formattedPercentage = `${calculatedGrossMarginPercentage}%`;
      setGrossMarginPercentage(formattedPercentage);
      }
      else{
        setGrossMarginPercentage(0)
      }
    }, [sales, grossMargin]);


    // useEffect(() => {
    //   const parsedpayroll = parseFloat(inventory) || 0;
    //   const parsedmarketing = parseFloat(marketing) || 0;
    //   const parseddepreciation = parseFloat(shipping) || 0;
    //   const parsedutilities = parseFloat(utilities) || 0;
    //   const parsedinsurance = parseFloat(insurance) || 0;
    //   const parsedrent = parseFloat(systemDevelopment) || 0;
    //   const parsedpayrollTaxes = parseFloat(humanResource) || 0;
    //   const parsedsoftware = parseFloat(licenses) || 0;
    //   const parsedotherExpense = parseFloat(officeEquipments) || 0;
    //   const parsedleasedEquipment = parseFloat(customTaxes) || 0;
    //   const calculatedTotalExpense = (parsedpayroll + parsedmarketing + parseddepreciation + parsedutilities + parsedinsurance + parsedrent  + parsedpayrollTaxes + parsedsoftware +parsedotherExpense + parsedleasedEquipment).toFixed(2);
    //   setTotalExpense(calculatedTotalExpense);
    // }, [inventory, marketing, shipping, utilities, insurance, systemDevelopment, humanResource, licenses, customTaxes, officeEquipments]);
    
    useEffect(() => {
      // Parsing all expenses as floats and summing them up
      const parsedInventory = parseFloat(inventory) || 0;
      const parsedMarketing = parseFloat(marketing) || 0;
      const parsedShipping = parseFloat(shipping) || 0;
      const parsedUtilities = parseFloat(utilities) || 0;
      const parsedInsurance = parseFloat(insurance) || 0;
      const parsedSystemDevelopment = parseFloat(systemDevelopment) || 0;
      const parsedHumanResource = parseFloat(humanResource) || 0;
      const parsedLicenses = parseFloat(licenses) || 0;
      const parsedOfficeEquipments = parseFloat(officeEquipments) || 0;
      const parsedCustomTaxes = parseFloat(customTaxes) || 0;
      const parsedFuelAndGas = parseFloat(fuelAndGas) || 0;
      const parsedTravelsMealsAndEntertainments = parseFloat(travelsMealsAndEntertainments) || 0;
      const parsedEquipmentRental = parseFloat(equipmentRental) || 0;
      const parsedAdvertisingAndPromotions = parseFloat(advertisingAndPromotions) || 0;
      const parsedWebsiteDevelopment = parseFloat(websiteDevelopment) || 0;
      const parsedToolsAndEquipment = parseFloat(toolsAndEquipment) || 0;
      const parsedSalaryAndWages = parseFloat(salaryAndWages) || 0;
      const parsedBankCharges = parseFloat(bankCharges) || 0;
      const parsedShippingAndLogisticsCost = parseFloat(shippingAndLogisticsCost) || 0;
      const parsedOtherExpenses = parseFloat(otherExpenses) || 0;
      const parsedGovernmentFees = parseFloat(governmentFees) || 0;
      const parsedCommunicationAndTelecom = parseFloat(communicationAndTelecom) || 0;
      const parsedCarInsurance = parseFloat(carInsurance) || 0;
      const parsedMembershipAndSubscriptions = parseFloat(membershipAndSubscriptions) || 0;
      const parsedCarMaintenanceAndRepairs = parseFloat(carMaintenanceAndRepairs) || 0;
      const parsedMaintenanceAndRepairs = parseFloat(maintenanceAndRepairs) || 0;
      const parsedRent = parseFloat(rent) || 0;
      const parstationeriesAndSupplies = parseFloat(stationeriesAndSupplies) || 0;
  
      // Calculate the total expense
      const total = (
        parsedInventory +
        parsedMarketing +
        parsedShipping +
        parsedUtilities +
        parsedInsurance +
        parsedSystemDevelopment +
        parsedHumanResource +
        parsedLicenses +
        parsedOfficeEquipments +
        parsedCustomTaxes +
        parsedFuelAndGas +
        parsedTravelsMealsAndEntertainments +
        parsedEquipmentRental +
        parsedAdvertisingAndPromotions +
        parsedWebsiteDevelopment +
        parsedToolsAndEquipment +
        parsedSalaryAndWages +
        parsedBankCharges +
        parsedShippingAndLogisticsCost +
        parsedOtherExpenses +
        parsedGovernmentFees +
        parsedCommunicationAndTelecom +
        parsedCarInsurance +
        parsedMembershipAndSubscriptions +
        parsedCarMaintenanceAndRepairs +
        parsedMaintenanceAndRepairs +
        parsedRent +
        parstationeriesAndSupplies
      ).toFixed(2);

  
      
      setTotalExpense(parseFloat(total));
    }, [
      inventory,
      marketing,
      shipping,
      utilities,
      insurance,
      systemDevelopment,
      humanResource,
      licenses,
      officeEquipments,
      customTaxes,
      fuelAndGas,
      travelsMealsAndEntertainments,
      equipmentRental,
      advertisingAndPromotions,
      websiteDevelopment,
      toolsAndEquipment,
      salaryAndWages,
      bankCharges,
      shippingAndLogisticsCost,
      otherExpenses,
      governmentFees,
      communicationAndTelecom,
      carInsurance,
      membershipAndSubscriptions,
      carMaintenanceAndRepairs,
      maintenanceAndRepairs,
      rent
    ]);
  

    useEffect(()=>{
      if(sales !== null && sales !== undefined){
      const parsedSales = parseFloat(sales) || 0;
      const parsedotherProductionExpenses = parseFloat(otherProductionExpenses) || 0;
      const parsedtotalExpense = parseFloat(totalExpense) || 0;
      setEbitda((parsedSales - parsedotherProductionExpenses - parsedtotalExpense).toFixed(2));
      }
      else{
        setEbitda(0);
      }
    },[sales, otherProductionExpenses , totalExpense])
    

    useEffect(()=>{
      if( sales !== null && sales !== undefined){
      const parsedebitda = parseFloat(ebitda) || 0;
      const parsedinterestExpense = parseFloat(interestExpense) || 0;
      // const parsedtaxes = parseFloat(taxes) || 0;
      setNetProfit((parsedebitda - parsedinterestExpense).toFixed(2));
      }   
      else{
        setNetProfit(0);
      }
    },[ebitda, interestExpense, sales])




    const onSubmit = () => {
      if(IncomeSheetPeriod !== null && IncomeSheetPeriod !== '' && IncomeSheetPeriod !== undefined){
      const serverData = new FormData()
      serverData.append('incomePeriod', IncomeSheetPeriod);
      serverData.append('sales', sales);
      serverData.append('otherProductionExpenses', otherProductionExpenses);
      serverData.append('totalCostOfSales', totalCostOfSales);
      serverData.append('grossMargin', grossMargin);
      serverData.append('grossMarginPercentage', grossMarginPercentage);

      serverData.append('fuel_and_gas', fuelAndGas || 0);
serverData.append('travels_meals_and_entertainments', travelsMealsAndEntertainments || 0);
serverData.append('equipment_rental', equipmentRental || 0);
serverData.append('advertising_and_promotions', advertisingAndPromotions || 0);
serverData.append('website_development', websiteDevelopment || 0);
serverData.append('tools_and_equipment', toolsAndEquipment || 0);
serverData.append('salary_and_wages', salaryAndWages || 0);
serverData.append('bank_charges', bankCharges || 0);
serverData.append('shipping_and_logistics_cost', shippingAndLogisticsCost || 0);
serverData.append('other_expenses', otherExpenses || 0);
serverData.append('government_fees', governmentFees || 0);
serverData.append('communication_and_telecom', communicationAndTelecom || 0);
serverData.append('car_insurance', carInsurance || 0);
serverData.append('membership_and_subscriptions', membershipAndSubscriptions || 0);
serverData.append('car_maintenance_and_repairs', carMaintenanceAndRepairs || 0);
serverData.append('maintenance_and_repairs', maintenanceAndRepairs || 0);
serverData.append('rent', rent || 0);
serverData.append('stationeries_and_supplies', stationeriesAndSupplies || 0);
serverData.append('inventory', inventory || 0);
      // serverData.append('utilities', marketing);
      // serverData.append('marketing', marketing);
      // serverData.append('humanResource', humanResource);
      // serverData.append('insurance', utilities);
      // serverData.append('licenses', insurance);
      // serverData.append('systemDevelopment', systemDevelopment);
      // serverData.append('officeEquipments', officeEquipments);
      // serverData.append('customTaxes', customTaxes);
      // serverData.append('shipping', shipping);

      serverData.append('totalExpense', totalExpense);
      serverData.append('ebitda', ebitda);
      serverData.append('interestExpense', interestExpense);
      // serverData.append('taxes', taxes);
      serverData.append('netProfit', netProfit);
      axios({
          method: "POST",
          url:add_income_statement,
          data: serverData,
      }).then(res => {
          if (!res.data.error) {
            // setValue(2);
            setOpen(true)
            setMessage(res.data.message)
            setStatus(true)
            setColor(true)
            setIncomeSheetPeriod(null);
            setSales(0);
            setOtherProductionExpenses(0);
            setTotalCostOfSales(0);
            setGrossMargin(0);
            setGrossMarginPercentage(0);
            setInventory(0);
            setMarketing(0);
            setShipping(0);
            setOfficeEquipments(0);
            setUtilities(0);
            setInsurance(0);
            setSystemDevelopment(0);
            setLicenses(0);
            setCustomTaxes(0);
            setHumanResource(0);
            setFinancialYear(null)
            setTotalExpense(0);
            setEbitda(0);
            setInterestExpense(0);
            datePickerRef.current.value = null;
            setNetProfit(0);
          } else {
          setOpen(true)
          setMessage(res.data.message)
          setStatus(false)
          setColor(false)
          }
      }).catch(err => {
          console.log(err)
      });
    }
    else{
    setMessage('Choose a Period');
    setOpen(true)
    setStatus(false)
    setColor(false) 
  }
}

  return (
      <Box p={1}>

<SnackBar open={open} setOpen={setOpen} status={status} color={color} message={message} />

    <Box component={Card} p={3} boxShadow={4}>
    <Grid container>
    <Stack spacing={4} textAlign='left'>

    <Box pt={1} pb={1}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Box display='flex' flexDirection={{lg:'row', md:'row', sm:'column', xs:'column'}} gap={1}>
    <DatePicker
    views={['year']}
    label="Select Year"
    openTo='Year'
    value={financialYear}
    onChange={handleDateChange}
    renderInput={(params) => <TextField {...params} helperText={null} />}
    />
            {/* <TextField
          id="financial-year"
          label="Financial Year"
          value={IncomeSheetPeriod}
          inputRef={datePickerRef}
          sx={{mx:2}}
          InputProps={{
            readOnly: true,
             // Disable editing of the input field
          }}
          InputLabelProps={{
            shrink:true
          }}
        /> */}
       </Box>
    </LocalizationProvider>
    </Box>

    <Stack spacing={3} borderBottom='1px solid silver' pb={2}>
    <Box textAlign='left'>
    <Typography variant='h6' color='#616e80' fontWeight={600}>(A) Sales</Typography>
    </Box>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(1A) Sales</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={sales}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs: "column" }}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(2A) Other Production Expenses</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <CustomTextField
        value={otherProductionExpenses}
    onChange={setOtherProductionExpenses}
    validationRegex={/^[0-9]*\.?[0-9]*$/}
    errorMessage={"Only Numeric Values are Allowed"}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography variant='subtitle1' fontWeight={600}>(4A) Gross Margin</Typography>
    <Typography variant='caption'>(1A - 2A)</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <TextField 
    size='small' 
    variant="outlined"
    value={grossMargin}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography variant='subtitle1' fontWeight={600}>(5A) Gross Margin %</Typography>
    <Typography variant='caption'>(4A / 1A)</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <TextField 
    size='small' 
    value={grossMarginPercentage}
    variant="outlined"
    />
    </Grid>
    </Box>
    </Stack>

    <Stack spacing={3} borderBottom='1px solid silver' pb={2}>
    <Box textAlign='left'>
    <Typography variant='h6' color='#616e80' fontWeight={600}>(B) Expenses</Typography>
    </Box>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(1B) Advertising and Promotions</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={advertisingAndPromotions}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs: "column" }}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(2B) Bank Charges</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <TextField 
    size='small' 
    variant="outlined"
    value={bankCharges}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(3B) Car Insurance</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <CustomTextField
    value={carInsurance}
    validationRegex={/^[0-9]*\.?[0-9]*$/}
    errorMessage={"Only Numeric Values are Allowed"}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(4B) Car Maintenance and Repairs</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <CustomTextField
    value={carMaintenanceAndRepairs}
    validationRegex={/^[0-9]*\.?[0-9]*$/}
    errorMessage={"Only Numeric Values are Allowed"}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(5B) Communication and Telecom</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={communicationAndTelecom}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(6B) Equipment Rental</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={equipmentRental}
    />
    </Grid>
    </Box>


    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(7B) Fuel and Gas</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={fuelAndGas}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(8B) Government Fees</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <CustomTextField
    value={governmentFees}
    validationRegex={/^[0-9]*\.?[0-9]*$/}
    errorMessage={"Only Numeric Values are Allowed"}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(9B) Inventory</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={inventory}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(10B) Maintenance and Repairs</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={maintenanceAndRepairs}
    />
    </Grid>
    </Box>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(11B) Membership and Subscriptions</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={membershipAndSubscriptions}
    />
    </Grid>
    </Box>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(12B) Other Expenses</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={otherExpenses}
    />
    </Grid>
    </Box>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(13B) Rent</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={rent}
    />
    </Grid>
    </Box>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(14B) Salary and Wages</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={salaryAndWages}
    />
    </Grid>
    </Box>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(15B) Shipping and Logistics Cost</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={shippingAndLogisticsCost}
    />
    </Grid>
    </Box>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(16B) Stationeries and Supplies</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={stationeriesAndSupplies}
    />
    </Grid>
    </Box>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(17B) Tools and Equipment</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={toolsAndEquipment}
    />
    </Grid>
    </Box>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(18B) Travels, Meals and Entertainments</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={travelsMealsAndEntertainments}
    />
    </Grid>
    </Box>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(19B) Website Development</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <TextField 
    size='small' 
    variant="outlined"
    value={websiteDevelopment}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
    <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography variant='subtitle1' fontWeight={600}>(20B) Total Operating Expenses</Typography>
    <Typography variant='caption'>SUM (1B : 19B)</Typography>
    </Grid>
    <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <TextField 
    size='small' 
    value={totalExpense}
    variant="outlined"
    />
    </Grid>
    </Box>
    </Stack>

    <Stack spacing={3} borderBottom='1px solid silver' pb={2}>
    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(1C) Earnings Before Interest, Taxes, Depreciation and Amortization (EBITDA)</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <CustomTextField
    value={ebitda}
    onChange={setEbitda}
    validationRegex={/^[0-9]*\.?[0-9]*$/}
    errorMessage={"Only Numeric Values are Allowed"}
    />
    </Grid>
    </Box>

    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs: "column" }}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(2C) Interest Expenses</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
     <CustomTextField
    value={interestExpense}
    onChange={setInterestExpense}
    validationRegex={/^[0-9]*\.?[0-9]*$/}
    errorMessage={"Only Numeric Values are Allowed"}
    />
    </Grid>
    </Box>

    {/* <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography>(3C) Taxes</Typography>
    </Grid>
     <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <TextField 
    size='small' 
    variant="outlined"
    value={taxes}
    />
    </Grid>
    </Box>

    <Box pt={1}>
    </Box> */}


    <Box display='flex' justifyContent='start' flexDirection={{ lg: 'row', md: 'row', sm: 'row', xs:"column"}}>
    <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <Typography variant='subtitle1' fontWeight={600}>Net Profit</Typography>
    <Typography variant='caption'>(1C + 2C )</Typography>
    </Grid>
    <Grid item xs={6} sm={6} md={6} lg={6} px={1}>
    <TextField 
    size='small' 
     value={netProfit}
    variant="outlined"
    />
    </Grid>
    </Box>
    </Stack>


    <Box>
    <Grid item xs={12} sm={12} md={12} lg={12} display='flex' justifyContent='center'>
    <Button onClick={onSubmit} variant='contained' fullWidth   color='warning'>Submit</Button> 
    </Grid>
    </Box>

    </Stack>
    </Grid>
    </Box>


      </Box>
  )
}
